import { yupResolver } from '@hookform/resolvers/yup';
import { useNotifications } from '@toolpad/core';
import { useForm } from 'react-hook-form';
import { TextFieldElement } from 'react-hook-form-mui';
import * as Yup from 'yup';
import { Box, Stack, Typography } from '@mui/material';

import { Logo, MaskedTextFieldElement } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { BusinessSignup } from '@barboxx/models';
import { PHONE_REGEX, ZIP_CODE_REGEX } from '@barboxx/types';

import { RootContainer, StyledForm, SubmitButton } from '../StyledComponents';

const SIGNUP_SCHEMA = Yup.object().shape({
    firstName: Yup.string().trim().required(),
    lastName: Yup.string().trim().required(),
    phone: Yup.string()
        .matches(PHONE_REGEX, 'Must be a phone number')
        .required(),
    email: Yup.string().email('Must match and email address').trim().required(),
    businessName: Yup.string().trim().required(),
    address: Yup.object({
        street: Yup.string().trim().default(''),
        city: Yup.string().trim().default(''),
        state: Yup.string().trim().default(''),
        zip: Yup.string().matches(ZIP_CODE_REGEX).required(),
    }).required(),
});

export default function SignUp() {
    const notifications = useNotifications();
    const formContext = useForm<BusinessSignup.CreateRequest>({
        resolver: yupResolver(SIGNUP_SCHEMA),
    });

    const onSubmit = (values: BusinessSignup.CreateRequest) =>
        Api.Authentication.Users.businessSignup(values)
            .then(() => {
                notifications.show('Successfully signed up!', {
                    severity: 'success',
                });
                // formContext.reset();
            })
            .catch(error => {
                notifications.show(error.message, {
                    severity: 'error',
                });
            });

    return (
        <RootContainer maxWidth="xs">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
            >
                <Logo />
                <Typography
                    margin={2}
                    variant="h5"
                    align="center"
                    color="textPrimary"
                >
                    Request Demo
                </Typography>

                <StyledForm onSuccess={onSubmit} formContext={formContext}>
                    <Stack gap={2}>
                        <Typography variant="subtitle1" color="textPrimary">
                            Contact Info
                        </Typography>
                        <TextFieldElement
                            label="First Name"
                            name="firstName"
                            required
                            autoComplete="given-name"
                        />
                        <TextFieldElement
                            label="Last Name"
                            name="lastName"
                            required
                            autoComplete="family-name"
                        />
                        <MaskedTextFieldElement
                            name="phone"
                            label="Phone Number"
                            type="tel"
                            inputProps={{
                                mask: '+1 (#00) 000-0000',
                                definitions: {
                                    '#': /[1-9]/,
                                },
                            }}
                        />
                        <TextFieldElement
                            label="Email"
                            name="email"
                            type="email"
                            required
                            autoComplete="email"
                        />

                        <Typography variant="subtitle1" color="textPrimary">
                            Business Info
                        </Typography>

                        <TextFieldElement
                            label="Business Name"
                            name="businessName"
                            required
                            autoFocus
                            autoComplete="organization"
                        />

                        <TextFieldElement
                            required
                            label="Zip Code"
                            name="address.zip"
                            autoComplete="postal-code"
                        />

                        <SubmitButton
                            type="submit"
                            color="primary"
                            variant="contained"
                            loading={formContext.formState.isSubmitting}
                            disabled={!formContext.formState.isDirty}
                        >
                            Sign Up
                        </SubmitButton>
                    </Stack>
                </StyledForm>
            </Box>
        </RootContainer>
    );
}
